import React, { useMemo } from 'react';
import { MenuItem, useMediaQuery, useTheme } from '@mui/material';
import { NavMenu } from './NavMenu';
import { Gray } from 'metabux/theme/colors';
import { DefaultNavItemRenderer } from './DefaultNavItemRenderer';
import { useLocation } from 'react-router-dom';
import Link from "metabux/components/Link/Link";

export const NavItem = ({
	active,
	willRender,
	children,
	...rest
}) => {

  const location = useLocation();

	const isActive = useMemo(() => {
    return rest.href === location.pathname;
  }, [location, rest.href]);

	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));
	if (willRender === false) return null;
	if (children) return <NavMenu active={active} {...rest} children={children} />
	return (
		<Link {...rest} value={rest.href} className={`${(active || isActive) && "active"}`} sx={{
			color: Gray[400],
			'&:hover': {
				color: 'white',
			},
			'&.active': {
				color: 'white',
				background: Gray[800],
			},
			padding: 2,
			borderRadius: 2,
			height: 48,
			justifyContent: isDesktop ? "auto" : "center",

		}}>
			<DefaultNavItemRenderer {...rest} />
		</Link>
	)
}